import React from 'react';
import PropTypes from 'prop-types';
import {Image, Line, List} from '@fupa/fupa-uikit';
import {LinkOnComponent} from 'app/components/links/link';
import {
  ProfileStatisticsRowContent,
  ProfileStatisticsRowInfo,
  ProfileStatisticsRowName,
  ProfileStatisticsRowPhoto,
  ProfileStatisticsRowStat,
  ProfileTypography,
} from 'app/components/profile/ProfileStyles';
import {getPlayerShortName} from 'app/helpers/helpers';

const ProfileStatisticsRow = ({profile, statistics, rank, rows, profileType, isActive}) => {
  const isDeactivated = profile.isDeactivated;
  const statsRows = rows.map(ele => (
    <ProfileStatisticsRowStat key={ele} align='center'>
      {statistics[ele]}
    </ProfileStatisticsRowStat>
  ));
  const ClubCaption =
    profileType === 'referee' ? (
      <ProfileTypography isDeactivated={isDeactivated} variant='caption1'>
        {profile.club ? profile.club.name : 'ohne Verein'}
      </ProfileTypography>
    ) : null;
  const activePlayer = isActive ? '*' : '';

  const listContent = (
    <List>
      <ProfileStatisticsRowStat align='start'>{rank}.</ProfileStatisticsRowStat>
      <ProfileStatisticsRowInfo>
        <ProfileStatisticsRowPhoto>
          <Image entity={profileType} circle={true} src={profile.image} ratio='1:1' width={32} height={32} />
        </ProfileStatisticsRowPhoto>
        <ProfileStatisticsRowName>
          <ProfileTypography isDeactivated={isDeactivated} variant='body1'>
            {getPlayerShortName(profile)}
          </ProfileTypography>
          {ClubCaption}
        </ProfileStatisticsRowName>
        {activePlayer}
      </ProfileStatisticsRowInfo>
      {statsRows}
    </List>
  );

  const content = isDeactivated ? (
    listContent
  ) : (
    <LinkOnComponent enablehover={true.toString()} to={`/${profileType}/${profile.slug}`}>
      {listContent}
    </LinkOnComponent>
  );

  return (
    <ProfileStatisticsRowContent isDeactivated={isDeactivated}>
      {content}
      <Line />
    </ProfileStatisticsRowContent>
  );
};

ProfileStatisticsRow.propTypes = {
  profile: PropTypes.object.isRequired,
  profileType: PropTypes.string.isRequired,
};

export default ProfileStatisticsRow;
